<!-- OVERLAY BUTTONS -->
<div class="w-full h-full absolute top-0 left-0 z-[3] pointer-events-none">

  <div class="w-full absolute top-0 left-0 flex justify-between items-center">
    <div class="m-4 flex items-center">
      <!-- Back -->
      @if (!isVrView && (is3dView || currentMap === 'seatmap')) {
      <button class="btn-overlay me-2 pe-1.5" (click)="onBack()">
        <img src="assets/img/icons/arrow-back.svg" class="" alt="Arrow back icon">
      </button>
      }
      <!-- Home -->
      @if (is3dView && currentMap === 'seatmap') {
      <button class="btn-overlay me-2 pb-[5px] ps-[5px]" (click)="onHome()">
        <img src="assets/img/icons/home.svg" class="" alt="Home icon">
      </button>
      }
    </div>

    @if (is3dView) {
    <div class="m-4 flex items-center">
      <!-- Link -->
      <!-- <button class="btn-overlay ms-2" (click)="onLink()">
        <img src="assets/img/icons/link.svg" class="" alt="Link icon">
      </button> -->
      <!-- Vr -->
      @if (isVrView) {
        <app-vr-button></app-vr-button>
      }
      <!-- Fullscreen -->
      <button class="btn-overlay ms-2" (click)="onFullscreen()">
        <img src="assets/img/icons/fullscreen.svg" class="" alt="Fullscreen icon">
      </button>
    </div>
    }
  </div>

  <!-- VR -->
  @if (!isVrView && is3dView) {
  <div class="m-8 absolute bottom-0 right-0">
    <app-stream-button></app-stream-button>
  </div>
  }

</div>